var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.tabs),function(tab){return _c('div',{key:tab,staticClass:"inline-block mr-2 p-1 pl-3 pr-3 border cursor-pointer transition-all duration-500 select-none shadow-lg",class:[
      _vm.selectedTab === tab
        ? 'text-white bg-secondary-100 border-secondary-100'
        : 'text-gray-500 hover:text-gray-700 bg-white',
    ],on:{"click":function($event){return _vm.$emit('select', tab)}}},[_vm._v("\n    "+_vm._s(tab)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }